import { GenericCollectionFactory } from "../../_generics";

export const MyInvitationsStore = GenericCollectionFactory("MY_INVITATIONS", "uid");